import { BLOCKS, Node } from '@contentful/rich-text-types';
import { styled } from '@zoopla-eng/zds-components/themes';
import { CONTENTFUL_RICH_TEXT_OPTIONS } from '@zoopla/cms/contentful-render-options';

const Text = styled('p', {
    color: '$textBody',
    marginBottom: '$S400',

    fontGroup: 'whisk',
    fontWeight: '$200',
    fontSize: '$whiskSmall',

    '@M100': {
        fontSize: '$whiskMedium'
    }
});

export const BANNER_RENDER_OPTIONS = {
    ...CONTENTFUL_RICH_TEXT_OPTIONS,
    renderNode: {
        ...CONTENTFUL_RICH_TEXT_OPTIONS.renderNode,
        [BLOCKS.PARAGRAPH]: (_node: Node, children: React.ReactNode) =>
            children && <Text>{children}</Text>
    }
};
